export default "__VITE_ASSET__DKNf43FN__"